if (!customElements.get('framework-sticky-scroll')) {
  customElements.define(
    'framework-sticky-scroll',
    class FrameworkStickyScroll extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => this.scrollToTarget());
      }

      scrollToTarget() {
        const selector = this.dataset.target || '#bundle-selector';
        const target = document.querySelector(selector);
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        if (target) {
          target.scrollIntoView({ behavior, block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior });
        }
      }
    }
  );
}
